import {useMutation} from 'react-query';
import {PostUpgradePlanCartToCart} from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

interface IUsePostUpgradePlanCartToCartProps {
  onSuccess?: () => void;
}
const usePostUpgradePlanCartToCart = ({
  onSuccess,
}: IUsePostUpgradePlanCartToCartProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPlanCartToCartPayload) => {
      return PostUpgradePlanCartToCart(payload);
    },
    onSuccess: () => {
      onSuccess && onSuccess();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePostUpgradePlanCartToCart;
